import type { IPermissionGroup } from "@/types/permission-group.types";

export type { IPermissionGroup };

export type IUserOrganization = {
  name: string;
  email: string;
};

export type IUser = {
  id: string;
  name: string;
  email: string;
  extraPermissions?: string[];
  blockedPermissions?: string[];
  permissionGroups?: IPermissionGroup[] | string[];
  permissionGroupIds?: string[];
  permissionCodes?: string[];
  disabled?: boolean;
  createdAt?: string;
  updatedAt?: string;
  organizations?: IUserOrganization[] | string[];
};

export type ICreateUserRequest = {
  email: string;
  password: string;
  name: string;
  permissionGroupIds?: string[];
  extraPermissions?: string[];
  blockedPermissions?: string[];
};

export type IUpdateUserRequest = {
  name?: string;
  permissionGroupIds?: string[];
  disabled?: boolean;
  extraPermissions?: string[];
  blockedPermissions?: string[];
};

export enum UserStatusFilter {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
